import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoriesRoutingModule } from './stories-routing.module';
import { LegacyDynamicFormModule as DynamicFormModule } from '@teamfoster/sdk/legacy-dynamic-form';
import { ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '../core/core.module';
import { DictionaryNgrxModule } from '@teamfoster/sdk/dictionary-ngrx';
import { StoriesOverviewComponent } from './containers/stories-overview/stories-overview.component';
import { StoryDetailComponent } from './containers/story-detail/story-detail.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import * as fromStore from './store';
import { MatLegacySnackBarModule } from '@angular/material/legacy-snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { TextUtilityModule } from '@teamfoster/sdk/text-utility';
import { CookieNgrxModule, StripEmbedPipe } from '@teamfoster/sdk/cookie-ngrx';
import { ImageModule, ResizeHtmlImagesPipe } from '@teamfoster/sdk/image';
import { InViewModule } from '@teamfoster/sdk/in-view';
import { Call2ActionStoryComponent } from './components/call2-action-story/call2-action-story.component';
import { ThemesModule } from '../themes/themes.module';
import { AuthModule } from '../auth/auth.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormModule } from '../form/form.module';
import { HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { GeoLocationModule } from '../geo-location/geo-location.module';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatIconModule } from '@angular/material/icon';
import { ContentModule } from '../content/content.module';
import { ContentSliderModule } from '../content-slider/content-slider.module';
import { DynamicHooksModule } from 'ngx-dynamic-hooks';
import { ThemeFiltersComponent } from '../standalone/theme-filters/theme-filters.component';
import { StoriesMapComponent } from './containers/stories-map/stories-map.component';
import { MapViewToggleComponent } from '../standalone/map-view-toggle/map-view-toggle.component';
@NgModule({
  declarations: [StoriesOverviewComponent, StoryDetailComponent, Call2ActionStoryComponent],
  imports: [
    CommonModule,
    StoriesRoutingModule,
    DynamicFormModule,
    ReactiveFormsModule,
    CoreModule,
    DictionaryNgrxModule,
    MatLegacySnackBarModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    ThemesModule,
    AuthModule,
    FormModule,
    ImageModule,
    StoreModule.forFeature(fromStore.featureKey, fromStore.reducers, {
      metaReducers: fromStore.metaReducers,
    }),
    EffectsModule.forFeature(fromStore.effects),
    TextUtilityModule,
    CookieNgrxModule,
    InViewModule,
    HttpClientModule,
    HttpClientJsonpModule,
    GeoLocationModule,
    ContentModule,
    MatSelectModule,
    MatFormFieldModule,
    ContentSliderModule,
    DynamicHooksModule,
    ThemeFiltersComponent,
    MapViewToggleComponent,
  ],
  providers: [ResizeHtmlImagesPipe, StripEmbedPipe],
})
export class StoriesModule {}
